module.exports = __webpack_public_path__ + "static/img/application3-4.eaa06be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/application/application3-4.jpg
// module id = HC2l
// module chunks = 0